import { render, staticRenderFns } from "./infobox.vue?vue&type=template&id=1ab22eaa&"
import script from "./infobox.vue?vue&type=script&lang=js&"
export * from "./infobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports